import {
  Box,
  Button,
  Divider,
  Icon,
  Paper,
  Skeleton,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
} from '@mui/material';

interface IFerramentasDeDetalheProps {
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  mostrarBotaoVoltar?: boolean;
  mostrarBotaoApagar?: boolean;
  mostrarBotaoSalvar?: boolean;
  disableBotaoSalvar?: boolean;
  disableBotaoSalvarEFechar?: boolean;
  mostrarBotaoSalvarEFechar?: boolean;
  disableBotaoImpressao?: boolean;
  mostrarBotaoImpressao?: boolean;
  disableBotaoImpressaopequeno?: boolean;
  mostrarBotaoImpressaopequeno?: boolean;
  disableBotaoImpressao1?: boolean;
  mostrarBotaoImpressao1?: boolean;
  mostrarBotaoNovoCarregando?: boolean;
  mostrarBotaoVoltarCarregando?: boolean;
  mostrarBotaoApagarCarregando?: boolean;
  mostrarBotaoSalvarCarregando?: boolean;
  mostrarBotaoSalvarEFecharCarregando?: boolean;
  mostrarBotaoImpressaoCarregando?: boolean;
  mostrarBotaoImpressaoCarregando1?: boolean;
  mostrarBotaoImpressaoCarregandopequeno?: boolean;
  aoClicarEmNovo?: () => void;
  aoClicarEmVoltar?: () => void;
  aoClicarEmApagar?: () => void;
  aoClicarEmSalvar?: () => void;
  aoClicarEmSalvarEFechar?: () => void;
  aoClicarEmImpressao?: () => void;
  aoClicarEmImpressao1?: () => void;
  aoClicarEmImpressaopequeno?: () => void;
}

export const FerramentasDeDetalheVendas: React.FC<IFerramentasDeDetalheProps> = ({
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  mostrarBotaoVoltar = true,
  mostrarBotaoApagar = true,
  mostrarBotaoSalvar = true,
  disableBotaoSalvar = false,
  disableBotaoSalvarEFechar = false,
  disableBotaoImpressao = false,
  disableBotaoImpressaopequeno = false,
  disableBotaoImpressao1 = false,
  mostrarBotaoSalvarEFechar = false,
  mostrarBotaoImpressao = true,
  mostrarBotaoImpressao1 = true,
  mostrarBotaoImpressaopequeno = true,
  mostrarBotaoNovoCarregando = false,
  mostrarBotaoVoltarCarregando = false,
  mostrarBotaoApagarCarregando = false,
  mostrarBotaoSalvarCarregando = false,
  mostrarBotaoSalvarEFecharCarregando = false,
  mostrarBotaoImpressaoCarregando = false,
  mostrarBotaoImpressaoCarregando1 = false,
  mostrarBotaoImpressaoCarregandopequeno = false,
  aoClicarEmNovo,
  aoClicarEmVoltar,
  aoClicarEmApagar,
  aoClicarEmSalvar,
  aoClicarEmSalvarEFechar,
  aoClicarEmImpressao,
  aoClicarEmImpressao1,
  aoClicarEmImpressaopequeno,
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const theme = useTheme();

  return (
    <Box
      component={Paper}
      marginX={1}
      padding={1}
      paddingX={2}
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="auto"
    >
      <Stack
  direction="row"
  flexWrap="wrap"
  justifyContent="flex-start"
  alignItems="center"
  rowGap={1}
  columnGap={1}
  width="100%"
>
        {mostrarBotaoVoltar && !mostrarBotaoVoltarCarregando && (
          <Button
            color="primary"
            variant="outlined"
            onClick={aoClicarEmVoltar}
            startIcon={<Icon>arrow_back</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              Voltar
            </Typography>
          </Button>
        )}
        {mostrarBotaoVoltarCarregando && <Skeleton width={110} height={60} />}

        {mostrarBotaoSalvar && !mostrarBotaoSalvarCarregando && (
          <Button
            color="primary"
            variant="contained"
            disabled={disableBotaoSalvar}
            onClick={aoClicarEmSalvar}
            startIcon={<Icon>save</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              Salvar
            </Typography>
          </Button>
        )}
        {mostrarBotaoSalvarCarregando && <Skeleton width={110} height={60} />}

        {mostrarBotaoSalvarEFechar && !mostrarBotaoSalvarEFecharCarregando && (
          <Button
            color="primary"
            variant="outlined"
            disabled={disableBotaoSalvarEFechar}
            onClick={aoClicarEmSalvarEFechar}
            startIcon={<Icon>save</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              Salvar e Fechar
            </Typography>
          </Button>
        )}
        {mostrarBotaoSalvarEFecharCarregando && <Skeleton width={180} height={60} />}

        {mostrarBotaoApagar && !mostrarBotaoApagarCarregando && (
          <Button
            color="error"
            variant="contained"
            onClick={aoClicarEmApagar}
            startIcon={<Icon>delete</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              Apagar
            </Typography>
          </Button>
        )}
        {mostrarBotaoApagarCarregando && <Skeleton width={110} height={60} />}

       
        {mostrarBotaoNovoCarregando && <Skeleton width={110} height={60} />}

        {mostrarBotaoImpressao && !mostrarBotaoImpressaoCarregando && (
          <Button
            color="primary"
            variant="outlined"
            disabled={disableBotaoImpressao}
            onClick={aoClicarEmImpressao}
            startIcon={<Icon>print</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              Imprimir
            </Typography>
          </Button>
        )}

        {mostrarBotaoImpressao1 && !mostrarBotaoImpressaoCarregando1 && (
          <Button
            color="primary"
            variant="outlined"
            disabled={disableBotaoImpressao1}
            onClick={aoClicarEmImpressao1}
            startIcon={<Icon>print</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              Imprimir Not
            </Typography>
          </Button>
        )}

        {mostrarBotaoImpressaopequeno && !mostrarBotaoImpressaoCarregandopequeno && (
          <Button
            color="primary"
            variant="outlined"
            disabled={disableBotaoImpressaopequeno}
            onClick={aoClicarEmImpressaopequeno}
            startIcon={<Icon>print</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              Imprimir i9
            </Typography>
          </Button>
        )} {mostrarBotaoNovo && !mostrarBotaoNovoCarregando && (
          <Button
            color="primary"
            variant="outlined"
            onClick={aoClicarEmNovo}
            startIcon={<Icon>add</Icon>}
            fullWidth={smDown}
          >
            <Typography variant="button" noWrap>
              {textoBotaoNovo}
            </Typography>
          </Button>
        )}
      </Stack>
    </Box>
  );
};
